import { Box, Paper, Typography } from '@mui/material'
import { styles } from './StatTile.styles'

export interface TileSpec {
  label: string
  subtitle?: string
  value: number | string
  icon: JSX.Element
  color: string
  panel: string
}

export const StatTile = ({ label, subtitle, value, icon, color, panel, grow = false }: TileSpec & { grow?: boolean }): JSX.Element => (
  <Paper variant='outlined' sx={styles.card(grow)} data-testid={`p2pStatTile-${label}`}>
    <Box sx={styles.heading}>
      <Typography variant='h5'>{label}</Typography>
      <Typography variant='body2' sx={styles.subtitle(subtitle != null)}>{subtitle ?? ' '}</Typography>
    </Box>
    <Box sx={styles.panel(color, panel)}>
      <Box sx={styles.iconWell(color)}>{icon}</Box>
      <Box sx={styles.valueWell}>
        <Typography variant='h1' sx={styles.value(color)}>{value}</Typography>
      </Box>
    </Box>
  </Paper>
)
